__turbopack_context__.v({
  "coverImage": "ProfileHeader-module-scss-module__VTIJWW__coverImage",
  "coverImageNsfwActions": "ProfileHeader-module-scss-module__VTIJWW__coverImageNsfwActions",
  "coverImageWrapper": "ProfileHeader-module-scss-module__VTIJWW__coverImageWrapper",
  "message": "ProfileHeader-module-scss-module__VTIJWW__message",
  "profileSection": "ProfileHeader-module-scss-module__VTIJWW__profileSection",
  "profileSectionWithCoverImage": "ProfileHeader-module-scss-module__VTIJWW__profileSectionWithCoverImage",
});
